// Webpack Imports
import * as bootstrap from 'bootstrap';

jQuery(document).ready(function($) {

( function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();
			}
		} );
	} );

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'focus',
		} );
	} );


	if ($('#store-map').length > 0) {

		console.log('store map');

		const mymap = L.map('store-map').setView([46.813744, 1.693057], 5);

		L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
			attribution: 'Map data © <a href="https://openstreetmap.org">OpenStreetMap</a> contributors',
			maxZoom: 16
		}).addTo(mymap);

		window.mymap = mymap;
		/*var markerImg = '../app/themes/isteli/assets/img/marker.svg';

		var myIcon = L.icon({
			iconUrl: markerImg,
			iconSize: [45, 50],
			iconAnchor: [24, 38],
			popupAnchor: [0, -50],
		});*/

		const brand = document.querySelector('meta[name="brand"]').content
		var markerImg = '../app/themes/isteli/assets/img/markers/marker_aa.svg';

		if(brand){
			var markerImgBrand = '../app/themes/isteli/assets/img/markers/marker_'+brand+'.svg';
		}else{
			var markerImgBrand = '../app/themes/isteli/assets/img/markers/marker_aa.svg';
		}

		
		var myIcon = L.icon({
			iconUrl: markerImg,
			iconSize: [22, 25],
			iconAnchor: [12, 19],
			popupAnchor: [0, -30],
		});

		var myBigIcon = L.icon({
			iconUrl: markerImgBrand,
			iconSize: [44, 50],
			iconAnchor: [24, 48],
			popupAnchor: [0, -50],

		});

	

		const provider = new window.GeoSearch.OpenStreetMapProvider();
		let page = 1;
		let allCampuses = [];

		var jsonUrl = '/wp-json/wp/v2/campus?per_page=100';

		if(blog_name[0] == 5){
			jsonUrl = '/wp-json/wp/v2/campus?per_page=100&filter[meta_key]=enseigne&filter[meta_value]=AFTRAL';
		}



		fetch(jsonUrl)
			.then(response => response.json())
			.then(function loadData(data) {
				if (data.length > 0) {
					allCampuses = allCampuses.concat(data);

					if (data.length < 100) {
						allCampuses.forEach(campus => {
							let marker = L.marker([campus.acf.latitude, campus.acf.longitude], {icon: myIcon}).addTo(mymap);

							let popupText = "<a href='" + campus.link + "'><b>" + campus.title.rendered + "</b></a>" +
								"<br /><br />" + campus.acf.adresse + "<br />" + campus.acf.code_postal + " " + campus.acf.ville;

							marker.bindPopup(popupText, {
								maxWidth: 200
							}); 
						});
					} else {
						page++;
						let nextPageUrl = `/wp-json/wp/v2/campus?per_page=100&page=${page}`;
						if (blog_name[0] == 5) {
							nextPageUrl += '&filter[meta_key]=enseigne&filter[meta_value]=AFTRAL';
						}

						return fetch(nextPageUrl)
							.then(response => response.json())
							.then(loadData);
					}
				}
			})
			.catch(error => {
				console.error(error);
			});


		const form = document.querySelector('.map-form');
		const input = form.querySelector('input[type="text"]');

		/*input.addEventListener('keypress', async (event) => {

			const results = await provider.search({ query: input.value });
			var list = document.createElement('ul');
			list.classList.add('list-group');
			var prevResult = [];
			$('#country-list .list-group').html('');
			for (var i = 0; i < 5; i++) {
				if(results[i] !== undefined){
				if(results[i].label.toLowerCase().includes('france')){
					if(!prevResult.includes(results[i].label)){
						var item = document.createElement('li');
						item.classList.add('list-group-item');
						item.innerHTML = '<a href="#" data-long="'+results[i].x+'" data-lat="'+results[i].y+'">'+ results[i].label +'</a>';
						list.appendChild(item);
					}
					prevResult.push(results[i].label);
				}
				}
			}
			var container = $('#country-list');
			container.append(list);
			container.parent().show();

		});*/

		let searchParams = new URLSearchParams(window.location.search);

		if(searchParams.has('lat') && searchParams.has('long')){
			let lat = searchParams.get('lat');
			let long = searchParams.get('long');
			mymap.setView([lat, long], 9);
		}

		if(searchParams.has('store') && searchParams.has('region')){
			var city = searchParams.get('store');
			var region = searchParams.get('region');
			$('#map-search').val(city);
			
			//chooseCity(city, region,mymap);

			setTimeout(function() {listCampus(city, region)}, 2000);
			setTimeout(function() {searchCity(city, mymap)}, 2000);

			


		}


		$('body').on('click', '#country-list a', function (e) {
			e.preventDefault();
			var city = $(this).attr('data-city');
			var region = $(this).attr('data-region');
			if($('body').hasClass('page-template-template-home')){
				$('input[name=region]').val(region);
				$('input[name=store]').val(city);
				var url = $('.map-form').attr('action');
				window.location.href = url+'?store='+city+'&region='+region;
			}
			$('#map-search').val(city);
			searchCity(city, mymap);
			$('#country-list').parent().hide();
			$('#country-list .list-group').html('');
			listCampus(city, region);
		});

	}

	let items = document.querySelectorAll('.carousel .carousel-item');

	items.forEach((el) => {
		const minPerSlide = 4;
		let next = el.nextElementSibling;
		for (var i=1; i<minPerSlide; i++) {
			if (!next) {
				next = items[0]
			}
			let cloneChild = next.cloneNode(true);
			el.appendChild(cloneChild.children[0]);
			next = next.nextElementSibling;
		}
	});

	async function chooseCity(city, region, map) {
		console.log('chooseCity',city,region,map);
		listCampus(city, region);
		
	}

	function displayCampuses(campuses) {
		campuses.forEach(campus => {
			let marker = L.marker([campus.acf.latitude, campus.acf.longitude], {icon: myIcon}).addTo(mymap);

			let popupText = "<a href='" + campus.link + "'><b>" + campus.title.rendered + "</b></a>" +
				"<br /><br />" + campus.acf.adresse + "<br />" + campus.acf.code_postal + " " + campus.acf.ville;

			marker.bindPopup(popupText, {
				maxWidth: 200
			});
		});
	}

	function findClosestMarker(map, latlng) {
		var closestDistance = Infinity;
		var closestMarker = null;
		map.eachLayer(function(layer) {
			if (layer instanceof L.Marker) {
				var distance = latlng.distanceTo(layer.getLatLng());
				if (distance < closestDistance) {
					closestDistance = distance;
					closestMarker = layer;
				}
			}
		});
		return closestMarker;
	}

	function searchCity(city, map) {

		const url = `https://nominatim.openstreetmap.org/search?q=${city}&format=json`;

		fetch(url)
			.then(response => response.json())
			.then(data => {
				const lat = data[0].lat;
				const lon = data[0].lon;

				map.setView([lat, lon], 7);

				var latlng = L.latLng(lat, lon);
				var closestMarker = findClosestMarker(map, latlng);

				if (closestMarker) {
					// Redefine Marker
					closestMarker.setIcon(myBigIcon);
					closestMarker.openPopup();
				}

				

			})
			.catch(error => {
				console.log(error);
			});
	}

	function listCity(query, type){
		const container = $('#country-list');
		//const list = document.createElement('ul');
		jQuery.ajax({
			url: 'https://geo.api.gouv.fr/'+type,
			type: 'GET',
			data: {
				nom: query
			},
			success: function(response) {

				var results = response;
				//list.classList.add('list-group');
				$('#country-list').html('');
				var html = '';

				var length = 10;

				if(results.length <= 10 ) length = results.length;

				for (var i = 0; i < length; i++) {
					if(results[i] !== undefined){
						html += '<li class="list-group-item"><a href="#" data-city="'+ results[i].nom +'" data-region="'+results[i].codeRegion+'">';
						if(type === 'communes')
							html += '('+results[i].codeDepartement+') ';
						html += results[i].nom +'</a></li>';
					}
				}
				container.append(html);
				container.parent().show();
			}
		});

	}

	$('#map-search').keyup(function(){
		$('#country-list').parent().hide();
		if($(this).val().length >= 1){
			listCity($(this).val(), 'communes');
			listCity($(this).val(), 'regions');
			//chooseCity($(this).val(), $(this).val(),window.mymap);


		}

	});

	function listCampus(search, region){
		var datas;
		datas = {action : 'load_campus'};
		if(search !== 'undefined'){
			datas = {action: 'load_campus', search: search, region: region}
		}
		jQuery.ajax({
			url: ajax_object.ajaxurl,
			type: 'POST',
			data: datas,
			success: function(response) {
				$('#list-campus').html(response);
			}
		});
	}

	listCampus();

} )();

	if($('body').hasClass('blog')){
		loadActus();
	}

	$('#load-more-btn').on('click',function(e){
		e.preventDefault();
		loadActus($(this).attr('data-page'), true);
	});

	$("select[name=campus_associes]").on('change',
		function(){
		loadActus();
		});
	$("select[name=type_associes]").on('change', function(){
		loadActus();
	});


	function loadActus(page = 1, more = false){
		var campus_associes = -1;
		var type_associes = -1;

		if($("select[name=campus_associes]").val() != -1) campus_associes = $("select[name=campus_associes]").val();

		if($("select[name=type_associes]").val() != -1) type_associes = $("select[name=type_associes]").val();


			$.ajax({
				url: ajax_object.ajaxurl,
				type: 'post',
				data: {
					action: 'load_more_actus',
					page: page,
					campus_associes: campus_associes,
					type_associes: type_associes
				},
				success: function(response){

					if(more)
						$('#liste-actus').append(response.data.articles);
					else
						$('#liste-actus').html(response.data.articles);
					page++;
					if(!response.data.more_posts_available) {
						$('#load-more').hide();
					}else{
						$('#load-more-btn').attr('data-page', page);
						$('#load-more').show();
					}
				}
			});
	}



	function loadFormations(page = 1, initialLoad = true) {

		var filieres = [];
		$('.filtre-filiere input[type="checkbox"]:checked').each(function() {
			filieres.push($(this).val());
		});

		var niveaux = [];
		$('.filtre-niveau input[type="checkbox"]:checked').each(function() {
			niveaux.push($(this).val());

			/*$('.filtre-type input[type="checkbox"]:checked').each(function() {
				if($(this).val() === 'Management & Gestion'){
					$(this).prop("checked", false)
				}
			});*/
		});


		var types = [];
		$('.filtre-type input[type="checkbox"]:checked').each(function() {
			types.push($(this).val());
		});

		var regions = [];
		$('.filtre-region input[type="checkbox"]:checked').each(function() {
			regions.push($(this).val());
		});

		$.ajax({
			url: ajax_object.ajaxurl,
			type: 'POST',
			dataType: 'json',
			data: {
				action: 'load_formations',
				filieres : JSON.stringify(filieres),
				niveaux : JSON.stringify(niveaux),
				types : JSON.stringify(types),
				regions : JSON.stringify(regions),
				page : JSON.stringify(page)
			},
			beforeSend: function() {
				$('#result-formations').html('<div class="w-100 pt-5 mt-5 text-center"><div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div></div>');
			}
		})
			.done(function(response) {
				$('#result-formations').html(response.data.html);
				//$('#pagination-container').html(response.data.pagination);

				var filieres = Object.values(response.data.filtres.filieres);
				var niveau = Object.values(response.data.filtres.niveau);
				var type = Object.values(response.data.filtres.rythme);
				var region = Object.values(response.data.filtres.region);

				$('.filtre-filiere input[type=checkbox]').each(function() {

					if(!filieres.includes($(this).val())){
						initialLoad ? $(this).parent().hide() : $(this).prop('disabled', true);
					}else{
						initialLoad ? $(this).parent().show() : $(this).prop('disabled', false);
					}

					const checkVal = $(this).val().replace(/\s/g, "");

					if(checkVal==='SupplyChain&Logistique' || checkVal==='SupplyChain&Transport'){
						$(this).parent().hide();
					}
				});

				$('.filtre-niveau input[type=checkbox]').each(function() {
					if(!niveau.includes($(this).val())){
						initialLoad ? $(this).parent().hide() : $(this).prop('disabled', true);
					}else{
						initialLoad ? $(this).parent().show() : $(this).prop('disabled', false);
					}
				});

				$('.filtre-type input[type=checkbox]').each(function() {

					if(!type.includes($(this).val())){
						initialLoad ? $(this).parent().hide() : $(this).prop('disabled', true);
					}else{
						initialLoad ? $(this).parent().show() : $(this).prop('disabled', false);
					}

					if($(this).val()==='VAE Validation' || $(this).val()==='VAE Accompagnement'){
						$(this).parent().hide();
					}

				});

				$('.filtre-region input[type=checkbox]').each(function() {

					if(!region.includes($(this).val())){
						initialLoad ? $(this).parent().hide() : $(this).prop('disabled', true);
					}else{
						initialLoad ? $(this).parent().show() : $(this).prop('disabled', false);
					}
				});

				$('#filtres-formation .collapse').each(function () {
					if($(this).is(':empty')){
						$(this).parent().hide();
					}
				});


				/*var container = $('#result-formations');
				var formations = container.find('.formation-container');

				formations.sort(function(a, b) {
					var countA = $(a).find('.type').length;
					var countB = $(b).find('.type').length;

					return countA - countB;
				});

				formations.each(function() {
					container.append(this);
				});*/

				if(blog_name[0] != 5 && blog_name[0] != 2) {

					var typeOrder = {
						'tempsplein': 1,
						'digital_distanciel': 2,
						'vae': 3,
						'formationcourte': 4
					};

					var typeSearch = '.type';

					var $container = $('#result-formations');
					var $formations = $container.find('.formation-container');

					$formations.sort(function (a, b) {
						var typeCountA = $(a).find(typeSearch).length;
						var typeCountB = $(b).find(typeSearch).length;

						if(blog_name[0] != 4){
							if (typeCountA !== typeCountB) {
                                return typeCountA - typeCountB;
                            }
						}

						var typesA = $(a).find(typeSearch).map(function () {
							return $(this).attr('class').split(' ')[1];
						}).get();
						var typesB = $(b).find(typeSearch).map(function () {
							return $(this).attr('class').split(' ')[1];
						}).get();

						typesA.sort(function (type1, type2) {
							return typeOrder[type1] - typeOrder[type2];
						});
						typesB.sort(function (type1, type2) {
							return typeOrder[type1] - typeOrder[type2];
						});

						for (var i = 0; i < typesA.length; i++) {
							if (typesA[i] !== typesB[i]) {
								return typeOrder[typesA[i]] - typeOrder[typesB[i]];
							}
						}

						return 0;
					});

					$formations.each(function () {
						$container.append(this);
					});


				}else if(blog_name[0] == 2){
					const ordre = [
						"Transport de Marchandises",
						"Transport de marchandises",
						"Logistique",
						"Supply Chain",
						"Supply Chain & Logistique",
						"Supply Chain & Transport",
						"Management & Gestion",
						"Commerce TL",
						"Commerce",
						"Transport de Voyageurs",
						"Transport de voyageurs",
						"Transport Sanitaire",
						"Transport sanitaire",
						"Maintenance",
						"Déménagement",
						"Travaux Public",
						"Douane",
						"Tourisme"
					];

					const niveaux = [ -1, 3, 4, 5, 6, 7, 8 ]; // Niveaux possibles

					// Fonction de tri en fonction de l'ordre et du niveau
					function trierElements() {
						$('.formation-container').each(function () {
							var types = [];
							var niveau = '';

							// Récupérer les types dans .type-order
							$(this).find('.type-order').each(function () {
								types.push($(this).text().trim());
							});

							// Récupérer le niveau depuis data-niveau
							niveau = $(this).find('[data-niveau]').attr('data-niveau');

							// Vérifier si l'élément correspond aux filtres
							let matchesType = types.some(type => ordre.indexOf(type) !== -1);
							let matchesNiveau = niveaux.indexOf(parseInt(niveau)) !== -1;

							// Appliquer les classes pour masquer ou afficher les éléments
							if (matchesType && matchesNiveau) {
								$(this).show(); // Afficher si cela correspond
							} else {
								$(this).hide(); // Masquer sinon
							}
						});

						// Trier les éléments en fonction de l'ordre des types et des niveaux
						let elements = $('.formation-container').toArray();
						elements.sort((a, b) => {
							const typeA = $(a).find('.type-order').text().trim();
							const typeB = $(b).find('.type-order').text().trim();
							const niveauA = parseInt($(a).find('[data-niveau]').attr('data-niveau'));
							const niveauB = parseInt($(b).find('[data-niveau]').attr('data-niveau'));
							return (ordre.indexOf(typeA) - ordre.indexOf(typeB)) || (niveaux.indexOf(niveauA) - niveaux.indexOf(niveauB));
						});

						// Réorganiser l'ordre dans le DOM
						$('.formation-container').parent().append(elements);
					}

					trierElements();

				}else{
						var ordre = [
							"Transport de Marchandises",
							"Transport de marchandises",
							"Logistique",
							"Transport de Voyageurs",
							"Maintenance",
							"Supply Chain",
							"Déménagement",
							"Transport Sanitaire",
							"Commerce",
							"Travaux Public",
							"Douane"
						];

						var typeOrder = {
							'tempsplein': 1,
							'digital_distanciel': 2,
							'vae': 3,
							'formationcourte': 4
						};

						var typeSearch = '.type';
						var $container = $('#result-formations');
						var $formations = $container.find('.formation-container');

						$formations.sort(function(a, b) {
							var textA = $(a).find('.type-order').text().trim().toLowerCase();
							var textB = $(b).find('.type-order').text().trim().toLowerCase();

							var libelleOrder = ordre.map(function(item) {
								return item.toLowerCase();
							}).indexOf(textA) - ordre.map(function(item) {
								return item.toLowerCase();
							}).indexOf(textB);

							if (libelleOrder !== 0) {
								return libelleOrder;
							}

							var typeCountA = $(a).find(typeSearch).length;
							var typeCountB = $(b).find(typeSearch).length;

							if (typeCountA !== typeCountB) {
								return typeCountA - typeCountB;
							}

							var typesA = $(a).find(typeSearch).map(function() {
								return $(this).attr('class').split(' ')[1];
							}).get();
							var typesB = $(b).find(typeSearch).map(function() {
								return $(this).attr('class').split(' ')[1];
							}).get();

							typesA.sort(function(type1, type2) {
								return typeOrder[type1] - typeOrder[type2];
							});
							typesB.sort(function(type1, type2) {
								return typeOrder[type1] - typeOrder[type2];
							});

							for (var i = 0; i < typesA.length; i++) {
								if (typesA[i] !== typesB[i]) {
									return typeOrder[typesA[i]] - typeOrder[typesB[i]];
								}
							}

							return 0;
						});

						$formations.each(function() {
							$container.append(this);
						});
				}

				const urlParams = new URLSearchParams(window.location.search);

				if (urlParams.has('niveau') && initialLoad) {
					const niveauValue = urlParams.get('niveau');
					$(`input[type="checkbox"][name="niveau[]"][value="${niveauValue}"]`).prop('checked', true);
					loadFormations(1, false);
				}

				if (urlParams.has('type') && initialLoad) {
					const typeValue = urlParams.get('type');
					$(`input[type="checkbox"][name="type[]"][value="${typeValue}"]`).prop('checked', true);
					loadFormations(1, false);
				}

			})
			.fail(function(jqXHR, textStatus, errorThrown) {
				console.log('Détails de l\'erreur AJAX : ', jqXHR.responseText);
				$('#result-formations').html('<div class="alert alert-danger">Une erreur est survenue. Veuillez réessayer.</div>');
			});
	}

	function loadOffresTalentsoft() {
		if (!document.body.classList.contains('page-id-290'))
			return;

		const region = $('#filtres-offres-talentsoft select[name="region"]').val();
		const contract = $('#filtres-offres-talentsoft select[name="contract"]').val();
		const date = $('#filtres-offres-talentsoft select[name="date"]').val();
		const job = $('#filtres-offres-talentsoft select[name="job"]').val();


		$.ajax({
			url: ajax_object.ajaxurl,
			type: 'POST',
			dataType: 'json',
			data: {
				action: 'load_offres_talentsoft',
				region : region,
				contract : contract,
				date : date,
				job : job,
			}
		})
		.done(function(response) {
			const params = new URLSearchParams({
				region: region,
				contract: contract,
				date: date,
				job: job,
			});
			window.history.replaceState(null, "Title", '?' + params);
			$('#result-offres-talentsoft').html(response.data.html);
			$('#total-offres-talentsoft').html(response.data.total_results);
		})
		.fail(function(textStatus, errorThrown) {
			console.error(textStatus, errorThrown);
		});
	}

	loadOffresTalentsoft();

	$('body').on('change','#filtres-offres-talentsoft select', function(e){
		loadOffresTalentsoft();
	});


	function loadOffres(page = 1) {
		var departements = $('#filtres-offres select[name="departments"]').val();
		var region = $('#filtres-offres select[name="region"]').val();
		var niveau = $('#filtres-offres select[name="niveau"]').val();
		var contrats = $('#filtres-offres select[name="contrats"]').val();
		var fonction = $('#filtres-offres select[name="fonction"]').val();

		$.ajax({
			url: ajax_object.ajaxurl,
			type: 'POST',
			dataType: 'json',
			data: {
				action: 'load_offres',
				departements : departements,
				region : region,
				niveau : niveau,
				contrats : contrats,
				fonction : fonction,
				page : page
			}
		})
			.done(function(response) {
				$('#result-offres').html(response.data.html);
				$('#total-offres').html(response.data.total_results);
				$('#pagination-container-offres').html(response.data.pagination);
			});
	}


	$('body').on('click', '#pagination-container-offres a', function(e) {
		e.preventDefault();
		var href = $(this).attr('href');
		var page = href.match(/page=(\d+)/)[1];
		loadOffres(page);
		$([document.documentElement, document.body]).animate({
			scrollTop: $("#result-offres").offset().top
		}, 1000);
	});


	function homeButtons(mobile){
		$('.wp-block-buttons').each(function () {
			var button = $(this).parent();
			if(mobile){
				button.hide();
				if(!$(this).parent().hasClass('btn-add'))
					button.parent().parent().append('<div class="col-12 mt-5 btn-add">'+button.html()+'</div>');
			}else{
				button.show();
				$('.btn-add').each(function(){
					$(this).remove();
				});
			}
		});
	}

	loadFormations();

	loadOffres();

	/*$('.filtre-filiere input[type="checkbox"], .filtre-niveau input[type="checkbox"], .filtre-type input[type="checkbox"]').change(function() {
		loadFormations();
	});*/

	$('body').on('change', '.filtre-filiere input[type="checkbox"], .filtre-niveau input[type="checkbox"], .filtre-type input[type="checkbox"], .filtre-region input[type="checkbox"]', function(e){
		loadFormations(1, false);
	});


	$('body').on('change','#filtres-offres select', function(e){
		loadOffres();
	});

	/*$('body').on('click', 'a.page-numbers', function(e) {
		e.preventDefault();
		var paged = $(this).attr('href');
		var page = paged.substr(paged.length - 1); // => "1"
		loadOffres(page);
	});*/

	$('body').on('click', 'a.btn-filtre-formations', function(e) {
		$('#modalFiltresFormations').modal('show');
		var modalBody = $('#modalFiltresFormations').find('.modal-body');
		if($.trim(modalBody.html())==''){
			modalBody.html($('#filtersContent').html());
		}
	});

	$('.play-video > a, .video-play > a').on('click', function(e){
		e.preventDefault();
		var src = $(this).attr('data-src');
		$("#video").attr('src',src + "?autoplay=1&amp;modestbranding=1&amp;showinfo=0" );

		// Handle video in the div
		e.preventDefault();
		var video = $(this).parent().parent().parent().find('.video')
		//console.log('Video', video);
		video.addClass('active');
		// Restart and play the video in iframe
		const iframe = video.find('iframe');
		iframe.attr('src', iframe.attr('src')+'?autoplay=1');
		


	});

	$('#videoModal').on('hide.bs.modal', function (e) {
		$("#video").attr('src','');
	});


	if($('body').hasClass('page-template-template-home')){
		let isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;
		if (isMobile) {
			homeButtons(true);
		}else{
			homeButtons(false);
		}


		$(window).resize(function() {
			let isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;
			if($(this).width() < 768)
				homeButtons(true);
			else
				homeButtons(false);
			});

		var is_modal_show = sessionStorage.getItem('alreadyShow');
		if(is_modal_show != 'already shown'){
			$('#popinModal').modal('show');
			sessionStorage.setItem('alreadyShow','already shown');
		}


		$('#navbar').on('hide.bs.collapse', function () {
			$('.navbar-brand #secondary').addClass('d-none');
			$('.navbar-brand #secondary').removeAttr('style');
		});

		$('#navbar').on('shown.bs.collapse', function () {
			$('.navbar-brand #secondary').removeClass('d-none');
			$('.navbar-brand #secondary').attr("style", "display:block;")
		});


	}

	if($('body').hasClass('single-formations')){
		$.ajax({
			url: ajax_object.ajaxurl,
			type: 'POST',
			dataType: 'json',
			data: {
				action: 'get_region_formation',
				code_produit : $('.ref_formation').html()
			}
		})
			.done(function(response) {
				response.forEach(item =>
					$('select[name="region_sel"]').append($('<option>', {
						value: item,
						text: item
					}))
				);

			});

        $('select[name="region_sel"]').on('change', function () {

            var selCampus = $('select[name="campus_sel"]');
			var campusLib;
			switch(blog_name[0]){
				case "3" : campusLib = 'Sélectionnez une école';
					break;
				case "4" : campusLib = 'Sélectionnez un institut';
					break;
				case "5" : campusLib = 'Sélectionnez un centre';
					break;
				default : campusLib = 'Sélectionnez un campus';
					break;
			}

            selCampus.html('<option value="" disabled="" selected="">'+campusLib+'</option>');

            $.ajax({
                url: ajax_object.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: {
                    action: 'get_campus_region',
                    region: $(this).val(),
                    code_produit : $('.ref_formation').html()
                }
            })
                .done(function(response) {
                    $('#sessions-date').html('');
					if ($('.txt-cpf').length) {
						$('#cpf-choose').show();
						$('#cpf-link').hide();
					}
                    response.forEach(item =>
                        $('select[name="campus_sel"]').append($('<option>', {
                            value: item.code,
                            text: item.title
                        }))
                    );

                });
        });

		$('select[name="campus_sel"]').on('change', function () {
			console.log('Campus :'+$(this).val()+' - code_produit : '+$('.ref_formation').html());
			$.ajax({
				url: ajax_object.ajaxurl,
				type: 'POST',
				dataType: 'json',
				data: {
					action: 'get_sessions_campus',
					campus: $(this).val(),
					code_produit : $('.ref_formation').html()
				}
			})
				.done(function(data) {
					$('#sessions-date').html('');
					if ($('.txt-cpf').length) {
						$('#cpf-choose').hide();
						$('#cpf-link').show();
					}
					if (data.length === 1 && data[0] === "Aucune session disponible") {
						$('#sessions-date').html(`<div class="no-session"></div>`);
					} else {
                        function parseDate(dateStr) {
                            let [day, month, year] = dateStr.split('/');
                            year = parseInt(year, 10);
                            year += 2000;
                            return new Date(year, month - 1, day);
                        }

                        data.sort((a, b) => {
                            const startDateA = parseDate(a.date.split(' > ')[0]);
                            const startDateB = parseDate(b.date.split(' > ')[0]);

                            if (startDateA.getTime() === startDateB.getTime()) {
                                const endDateA = parseDate(a.date.split(' > ')[1]);
                                const endDateB = parseDate(b.date.split(' > ')[1]);
                                return endDateA - endDateB;
                            }

                            return startDateA - startDateB;
                        });

						data.forEach(function(item) {
							const dateRange = item.date;
							const availability = item.dispo;

							let content = `<div class="date-item"><span class="date-range">${dateRange}</span>`;

							if (availability !== null) {
                                if(availability >1)
								    content += `<span class="availability" style="font-size:13px;"> (plus que ${availability} places disponibles)</span>`;
                                else
                                    content += `<span class="availability" style="font-size:13px;"> (plus que ${availability} place disponible)</span>`;
							}

							content += `</div>`;

							$('#sessions-date').append(content);
						});
					}
				});
		});


		$('#form-brochure').on('submit', function (e) {

			e.preventDefault();

			var idFormation = $('input[name="id_formation"]').val();
			var selCampus = $('select[name="centre"]').val();
			var nom = $('input[name="nom"]').val();
			var prenom = $('input[name="prenom"]').val();
			var tel = $('input[name="telephone"]').val();
			var email = $('input[name="email"]').val();
			var codeProduit = $('input[name="code"]').val();

			console.log(selCampus+' - '+nom+' - '+prenom+' - '+tel+' - '+email+' - '+codeProduit);

			$.ajax({
				url: ajax_object.ajaxurl,
				type: 'POST',
				dataType: 'json',
				data: {
					action: 'get_brochure',
					id_formation: idFormation,
					campus: selCampus,
					nom: nom,
					prenom: prenom,
					tel: tel,
					email: email,
					code_produit : codeProduit,
				}
			})
				.done(function(response) {
					var url = response.data.url_brochure;
					/*window.location.reload();
					window.open(url, '_blank');*/

					$('#modalBrochure').modal('hide');
					var link = document.createElement("a");
					link.href = url;
					link.target = "_blank";
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);

				});

		});


	}


	if($('#slide-general').length > 0){
		var splide = new Splide( '#slide-general', {
			perPage: 4,
			speed: 2000,
			rewind : true,
			pagination: false,
			autoplay: true,
			breakpoints: {
				640: {
					perPage: 2,
					gap: '.7rem',
				},
				480: {
					perPage: 1,
					gap: '.7rem',
				},
			},
		} );

		splide.mount();
	}


	if($('#partenaires-slide').length > 0){
		var splide = new Splide( '#partenaires-slide', {
			perPage: 4,
			speed: 2000,
			rewind : true,
			pagination: false,
			autoplay: true,
			breakpoints: {
				640: {
					perPage: 2,
					gap: '.7rem',
				},
				480: {
					perPage: 1,
					gap: '.7rem',
				},
			},
		} );

		splide.mount();
	}

	if($('#slide-temoignages').length > 0){
		var splideTemoignages = new Splide( '#slide-temoignages', {
			perPage: 4,
			rewind : true,
			pagination: false,
			breakpoints: {
				640: {
					perPage: 2,
					gap: '.7rem',
				},
				480: {
					perPage: 1,
					gap: '.7rem',
				},
			},
		} );

		var bar    = splideTemoignages.root.querySelector( '.slider-progress-bar' );

		splideTemoignages.on( 'mounted move', function () {
			var end  = splideTemoignages.Components.Controller.getEnd() + 1;
			var rate = Math.min( ( splideTemoignages.index + 1 ) / end, 1 );
			bar.style.width = String( 100 * rate ) + '%';
		} );

		splideTemoignages.mount();
	}


	if($('#slide-actualites').length > 0) {
		var splideActus = new Splide('#slide-actualites', {
			perPage: 4,
			rewind: true,
			pagination: false,
			breakpoints: {
				640: {
					perPage: 2,
					gap: '.7rem',
				},
				480: {
					perPage: 1,
					gap: '.7rem',
				},
			},
		});

		var barActus = splideActus.root.querySelector('.slider-actus-progress-bar');

		// Updates the bar width whenever the carousel moves:
		splideActus.on('mounted move', function () {
			var end = splideActus.Components.Controller.getEnd() + 1;
			var rate = Math.min((splideActus.index + 1) / end, 1);
			barActus.style.width = String(100 * rate) + '%';
		});

		splideActus.mount();
	}


	if($('#slide-metiers').length > 0) {
		var splideMetiers = new Splide( '#slide-metiers', {
			perPage: 4,
			rewind : true,
			pagination: false,
			breakpoints: {
				640: {
					perPage: 2,
					gap: '.7rem',
				},
				480: {
					perPage: 1,
					gap: '.7rem',
				},
			},
		} );

		var barMetiers    = splideMetiers.root.querySelector( '.slider-progress-bar' );

		splideMetiers.on( 'mounted move', function () {
			var end  = splideMetiers.Components.Controller.getEnd() + 1;
			var rate = Math.min( ( splideMetiers.index + 1 ) / end, 1 );
			barMetiers.style.width = String( 100 * rate ) + '%';
		} );

		splideMetiers.mount();
	}

	if($('#slide-formations').length > 0) {
		var splideFormations = new Splide( '#slide-formations', {
			perPage: 4,
			rewind : true,
			pagination: false,
			autoplay: true,
			breakpoints: {
				640: {
					perPage: 2,
					gap: '.7rem',
				},
				480: {
					perPage: 1,
					gap: '.7rem',
				},
			},
		} );

		var barFormations    = splideFormations.root.querySelector( '.slider-progress-bar' );

		splideFormations.on( 'mounted move', function () {
			var end  = splideFormations.Components.Controller.getEnd() + 1;
			var rate = Math.min( ( splideFormations.index + 1 ) / end, 1 );
			barFormations.style.width = String( 100 * rate ) + '%';
		} );

		splideFormations.mount();
	}

	if($('#slide-campus').length > 0) {
		var splideCampus = new Splide( '#slide-campus', {
			perPage: 4,
			rewind : true,
			pagination: false,
			autoplay: true,
			breakpoints: {
				640: {
					perPage: 2,
					gap: '.7rem',
				},
				480: {
					perPage: 1,
					gap: '.7rem',
				},
			},
		} );

		var barCampus    = splideCampus.root.querySelector( '.slider-progress-bar' );

		splideCampus.on( 'mounted move', function () {
			var end  = splideCampus.Components.Controller.getEnd() + 1;
			var rate = Math.min( ( splideCampus.index + 1 ) / end, 1 );
			barCampus.style.width = String( 100 * rate ) + '%';
		} );

		splideCampus.mount();
	}


	$('#menu-user-menu li').on('click', function () {
		var url = $(this).find('a').attr('href');
		window.location.href = url;
	});


	$('.instaShow').on('click', function () {

		var temoignageId = $(this).attr('data-id');

		$("#instaModal"+temoignageId).modal('show');
	});

	var myModalEl = document.getElementById('instaModal');
	if(myModalEl !== null){
		myModalEl.addEventListener('hidden.bs.modal', function (event) {
			$("#instaModal").find('#instaEmbed').html('');
		});
	}


	/*----- CF contact ----*/

	$("#contactStatus").on('change', function () {
		if($(this).val() === 'Une entreprise'){
			$('#contactSituation').hide();
		}else{
			$('#contactSituation').show();
		}
	});


	if($('body').hasClass('page-template-template-contact')){
		var now = new Date();
		var month = now.getMonth();
		var year = now.getFullYear();

		var names = ["Janvier","Février","Mars","Avril","Mai","Juin","Juillet","Août","Septembre","Octobre","Novembre","Décembre"];

		var res = [];
		for (var i = 0; i < 12; ++i) {
			res.push(names[month] + ' ' + year);
			if (++month === 12) {
				month = 0;
				++year;
			}
		}

		res.forEach(item => $("select[name='periode']").append($('<option>', {
			value: item,
			text: item
		})));


		var hiddenRegionInput = document.querySelector('input[type="hidden"][name*="region"]');
		var hiddenCampusInput = document.querySelector('input[type="hidden"][name*="campus"]');
		console.log('Campus'+ hiddenCampusInput.value);

			$.ajax({
				url: ajax_object.ajaxurl,
				type: 'POST',
				dataType: 'json',
				data: {
					action: 'get_region_campus',
					campus : hiddenCampusInput.value
				}
			})
				.done(function(response) {
					console.log(response.data.dep);

					var departementCodeAndName = response.data.dep; // à remplacer par la valeur dynamique

					var selectLieu = document.querySelector('select[name="lieu"]');

					if (selectLieu && departementCodeAndName) {
						for (var i = 0; i < selectLieu.options.length; i++) {
							var option = selectLieu.options[i];

							if (
								option.value === departementCodeAndName ||
								option.text === departementCodeAndName
							) {
								option.selected = true;
								break;
							}
						}
					}


				});


	}

	/*---- Analytics -----*/

	window.dataLayer = window.dataLayer || [];

	$('body').on('submit', 'form.map-form', function(e){
		window.dataLayer.push({
			'event': 'searchForm',
			'objet': $('#map-search').val()
		});
	});

	$('body').on('submit', 'form#more-info', function(e){
		window.dataLayer.push({
			'event': 'demandeInformationForm',
			'objet': '[' + $('select[name="region_sel"]').val() + ' ' + $('select[name="campus_sel"]').val() + ']'
		});
	});

	const element = document.getElementById('find-campus');
	element.onclick = function () {
		window.dataLayer.push({
			'event': 'clickCTA',
			'text': 'Trouver votre campus',
			'location': 'header'
		});
	};

	if($('body').hasClass('page-template-template-formations')){
		$('body').on('click', 'a.stretched-link', function(e){
			window.dataLayer.push({
				'event': 'clicFormation',
				'text-name': $(this).html()
			});

		});
	}


	// Formulaire 
	document.addEventListener('wpcf7mailsent', async function (event) {
		var inputs = event.detail.inputs;
		const formData = event.detail.formData;
		
		const object = {
			'event': 'contactForm',
			'objet': inputs[0].value,
			'user' : {
				'logged' : false
			}
	
		}

		if(formData.get('nom')){
			object.user.firstName = formData.get('nom').toLowerCase();
		}

		if(formData.get('prenom')){
			object.user.lastName = formData.get('prenom').toLowerCase();
		}

		if(formData.get('email')){
			if(formData.get('email').includes('@')){
				object.user.email = formData.get('email').toLowerCase();
			}
		}

		if(formData.get('tel')){
			// Regexp numéro international
			if(new RegExp(/^\+[1-9]{1}[0-9]{3,14}$/).test(formData.get('tel'))){
				object.user.phone = formData.get('tel');
			}
		}

		if(formData.get('liste-pays')){

			// Code pays
			// ISO 3166-1 alpha-2
			const codes = await fetch('/wp-json/wp/v2/countries').then(response => response.json());
			const code = codes.find(item => item.name === formData.get('liste-pays').toUpperCase()) ?? null;	
			if(code){
				object.user.country = code.code;
			}
		}

		if(formData.get('cp')){
			object.user.postcode = formData.get('cp').toLowerCase();
		}

		if(formData.get('ville')){
			object.user.city = formData.get('ville').toLowerCase();
		}

		if(formData.get('adresse')){
			object.user.address = formData.get('adresse').toLowerCase();
		}

		console.log(event.detail.contactFormId);


		console.log('object',object);

		window.dataLayer.push(object);

		if (event.detail.contactFormId == '742' || event.detail.contactFormId == '76bdf5c') {
			console.log('redirect');
			window.location.href = '/merci-pour-votre-message';
		}

	});


	// Handle Change Pays in Select and remove Lieu de formation
	
	const handleDisableLieuDeFormation = () => {
		console.log('handleDisableLieuDeFormation')
		const listePays = document.querySelector('select[name="liste-pays"]'); 
		const lieu = document.querySelector('select[name="lieu"]');
		const row = lieu?.parentElement?.parentElement?.parentElement?.parentElement;
		if (!listePays) {
			return;
		}
		listePays.addEventListener('change', (e) => {
			const selectedPays = e.target.value;
			console.log(selectedPays)
			if(row){
				if(selectedPays === 'France'){
					row.style.display = 'block';
					lieu.value = '01 - Ain';
				}else{
					row.style.display = 'none';
					lieu.value = '';

					const moreData = document.querySelector('.more-data');
					console.log('moreData',moreData)
					if(moreData){
						moreData.style.display = 'none';
					}

				}
			}

		})
	}

	handleDisableLieuDeFormation();


	// Handle Header on page contact
	const handleHeaderContact = () => {

		const headerEntreprise = document.querySelector('.header-entreprise');
		const headerParticulier = document.querySelector('.header-particulier');
		const status = document.querySelector('select[name="status"]');

		if(!status){
			return;
		}
		status.addEventListener('change', (e) => {
			const selectedStatus = e.target.value;
			if(selectedStatus === 'Une entreprise'){
				headerEntreprise.style.display = 'block';
				headerParticulier.style.display = 'none';
			}else{
				headerEntreprise.style.display = 'none';
				headerParticulier.style.display = 'block';
			}
		})

		headerEntreprise.style.display = 'none';
		headerParticulier.style.display = 'block';

	}
	handleHeaderContact();



function handleAjaxFiltersJpo(){

	console.log('handleAjaxFiltersJpo')

	const ajaxFilters = document.querySelector('.block-jpo .ajax-filters');
	console.log('ajaxFilters',ajaxFilters);
	if(!ajaxFilters){
		return;
	}
	const form = ajaxFilters.querySelector('form');

	//const regions_jpo = form.querySelector('select[name="regions_jpo"]');
	const campus_jpo = form.querySelector('select[name="campus_jpo"]');
	const periode_jpo = form.querySelector('select[name="periode_jpo"]');
	//regions_jpo.addEventListener('change', hanldeFilteringJpos);
	campus_jpo.addEventListener('change', hanldeFilteringJpos);
	periode_jpo.addEventListener('change', hanldeFilteringJpos);

	

	//console.log('handleAjaxFiltersJpo',regions_jpo,campus_jpo,periode_jpo);



}

const hanldeFilteringJpos = async (e) => {


	const name = e.target.name;
	const value = e.target.value;
	const adding = e.target.adding ?? false;

	// Add in url Params

	const url = new URL(window.location.href);
	const searchParams = new URLSearchParams(url.search);
	searchParams.set(name, value);
	url.search = searchParams.toString();
	window.history.pushState({}, null, url.toString());


	// Fetch data
	await filterJpo(adding);

	const see_more = document.querySelector('.block-jpo .see-more');


	if(see_more){
		see_more.addEventListener('click', (e) => {
			e.preventDefault();
			const page = parseInt(see_more.getAttribute('data-pagination') ?? 1) + 1;
			hanldeFilteringJpos({target: {name: 'page', value: page,adding:true}});
		})
	}




}

const generateLoader = () => {

	const container = document.createElement('div');
	container.classList.add('w-100','pt-5','mt-5','text-center');
	const spinner = document.createElement('div');
	spinner.classList.add('spinner-border');
	spinner.setAttribute('role','status');
	const span = document.createElement('span');
	span.classList.add('visually-hidden');
	span.innerHTML = 'Loading...';

	spinner.appendChild(span);
	container.appendChild(spinner);

	return container;

	//div.innerHTML = '<div class="w-100 pt-5 mt-5 text-center"><div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div></div>';
}

const filterJpo = async (adding = false) => {

	const qs = new URLSearchParams(window.location.search);
 
	// QS to Object
	const qsObj = {};
	for (const [key, value] of qs) {
		qsObj[key] = value;
	}

	const container = document.querySelector('.block-jpo .jpos');

	if(!adding){
		container.innerHTML = '';
	}

	const loader = generateLoader();
	container.insertAdjacentElement('beforeend', loader);


	const response = await fetch(ajax_object.ajaxurl, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
		},
		body: new URLSearchParams({
			action: 'load_jpo',
			...qsObj
		}),
	}).then(response => response.text());

	loader.remove();

	const responseDiv = document.createElement('div');
	responseDiv.innerHTML = response
	container.innerHTML = responseDiv.innerHTML;
}

handleAjaxFiltersJpo();











});



